export const FORGOT_PASSOWRD_REQUEST = 'FORGOT_PASSOWRD_REQUEST';
export const FORGOT_PASSOWRD_SUCCESS = 'FORGOT_PASSOWRD_SUCCESS';
export const FORGOT_PASSOWRD_FAILURE = 'FORGOT_PASSOWRD_FAILURE';
